import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastReusable } from '../../../../libs/core';

@Component({
  imports: [RouterModule, ToastReusable],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected title = 'superadmin';
}
